import { render, staticRenderFns } from "./JobAssignmentSummaryPanel.vue?vue&type=template&id=3625a21d&scoped=true&"
import script from "./JobAssignmentSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./JobAssignmentSummaryPanel.vue?vue&type=style&index=0&id=3625a21d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625a21d",
  null
  
)

export default component.exports